import { createAppStore } from '@muse/store'
import { webLogger } from '@muse-web/logger'
import { persistEngines } from '../config/persistConfig'

export const createStore = () =>
    createAppStore({
        persistEngines,
        actionContext: {
            logger: webLogger,
        },
        logger: webLogger,
    })

export type TAppStore = ReturnType<typeof createStore>
